import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import central from '../api/Central';
import Resultado from '../api/Resultado.js';
import Alert from '../components/Alert.js';
import Error from '../components/Error.js';
import Navegacao from '../components/Navegacao.js';


function Servico(props) {
    return (
        <tr>
            <td><div>{props.servico.inst_logradouro}
          {props.servico.inst_numero ? ", " + props.servico.inst_numero : "S/N"}
          {props.servico.inst_complemento ? ", " + props.servico.inst_complemento : ""}
          </div>
          <div>
          {props.servico.inst_bairro}
          {props.servico.inst_cidade 
          ? (props.servico.inst_bairro ? ", " : "") 
          + props.servico.inst_cidade + " - " + props.servico.inst_estado
          : "" }
          </div>
          </td>
            <td>{props.servico.statusacesso}</td>
            <td>{
            props.servico.statusacesso != 'LIBERADA' 
            && (props.servico.toleranciaconcedida 
            ? "Religação já concedida" 
            : <Link to={"/religar/" + props.servico.id} className="button">Religar</Link>)}</td>
        </tr>

    );
}

class Religar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itens: { rows: [] },
            disabled: false,
            erro: null,
            carregado: true
        }
    }

    componentDidMount() {
        this.carrega();
    }

    carrega() {
        this.setState({ carregando: true });
        central.requestAndCatch(
            "GET",
            "/religar",
            null,
            (payload) => {
                var itens = new Resultado(payload);
                this.setState({ itens: itens, carregado: true });
            },
            (msg) => {
                this.setState({ erro: "Erro ao consultar serviços: " + msg });
            },
            () => {
                this.setState({ carregando: false });
            });


    }

    render() {
        var tabela = (
            <table>
                <thead>
                    <tr>
                        <th>Serviço</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.itens.rows.map((item) => {
                        return (<Servico key={item.id} servico={item} />);
                    })}
                </tbody>
            </table>
        );

        var vazio = (<Alert type="info">Não existe nenhum serviço bloqueado.</Alert>);

        var erro = (<Error msg={this.state.erro} disabled={this.state.carregando} onButtonClick={this.carrega.bind(this)} buttonLabel="Tentar Novamente" />);

        var loader = (<Alert type="info">Carregando...</Alert>);

        var componente;
        if (this.state.carregando) {
            componente = loader;
        } else if (this.state.erro) {
            componente = erro;
        } else if (this.state.itens.rows.length === 0) {
            componente = vazio;
        } else {
            componente = tabela;
        }


        return (
            <section className="container">
                <Navegacao link="/" titulo="Religar serviço" />
                <section>
                    {componente}
                </section>
            </section>

        );

    }
}

export default Religar;